/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PropTypes from 'prop-types';
import PaymentStripeForm from './stripeForm';

function PaymentStripe({ clientinfo, code }) {
  const stripePromise = loadStripe(
    'pk_test_51P3GTTANqiN7L7eAikHPDlRKliKMSqfUitsjeSXnUWb3rMvyQTBj6icrPJXaARcWtaKWJ8Gwo2BtPTua3Qn1YrS600hOnsmkvf'
  );

  return (
    <Elements stripe={stripePromise}>
      <PaymentStripeForm clientinfo={clientinfo} code={code} />
    </Elements>
  );
}

PaymentStripe.propTypes = {
  code: PropTypes.string.isRequired,
  clientinfo: PropTypes.func.isRequired
};

export default PaymentStripe;
